import { css } from 'styled-components';
import { above, Breakpoint } from './breakpoints';

export const resetBase = css`
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    //font-size: 100%;
    //font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;

export const customResetBase = css`
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  a {
    text-decoration: unset;
    color: inherit;
  }

  button {
    margin: 0;
    border: 0;
    font: inherit;
    background-color: unset;
  }

  figure {
    line-height: 0;
  }

  details > summary::-webkit-details-marker {
    display: none;
  }

  input {
    margin: 0;
  }
`;

const customReset = css`
  html {
    box-sizing: border-box;
  }

  html,
  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
    width: 100%;
    height: 100%;
    min-width: 100vw;
    min-height: 100vh;

    color: var(--bo-black);

    overscroll-behavior: none;
  }

  body {
    background: white;
  }

  button,
  a {
    color: inherit;
  }

  #___gatsby,
  #gatsby-focus-wrapper {
    height: 100%;
  }

  ${above(Breakpoint.max + 1)} {
    body {
      background-image: url(./grid@3x.png);
      background-size: 137px 137px;
      background-repeat: repeat;
      background-position: 50% 50%;
    }

    #gatsby-focus-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  * {
    font-style: normal;
    font-weight: normal;
  }
`;

const reset = css`
  /* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/
  html,
  body {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
  }
  body {
    font-size: 16px;
    line-height: 1;
  }

  ${resetBase}
  ${customReset}
  ${customResetBase}
`;

export default reset;
